export enum ApplyRuleFor {
Employee,
Employer,
Both,
}
